import type { FC } from "react";

const PlayingIndicator: FC = () => (
  <div
    data-testid="playing-indicator"
    className="flex h-6 w-6 items-center justify-center"
  >
    <div className="flex h-4 w-4 items-center justify-center rounded-full bg-primary/25">
      <div className="h-2 w-2 rounded-full bg-primary" />
    </div>
  </div>
);

export default PlayingIndicator;
